/**
 * Connect moved from connect.(stg.)crewdle.ai to app.(stg.)crewdle.ai
 * (2026-10-07). The old host stays served by the same Hosting site; a plain
 * browser tab on it is sent to the same path on the new host before Angular
 * boots. Contexts bound to the old host stay put:
 *  - embedded (Microsoft Teams tab, any iframe) — the Teams app's validDomains
 *    and SSO resource (api://connect.crewdle.ai/…) name the old host;
 *  - packaged shells (Electron desktop, Capacitor) — their navigation
 *    allowlists treat only connect.{domain} as in-app;
 *  - the Teams SSO popup pages, which Teams opens on the old host.
 * Partner white-label domains are never touched.
 */
const OLD_HOST = /^connect\.((?:stg\.)?crewdle\.ai)$/;
const OLD_HOST_ONLY_PATHS = /^\/(auth-start|auth-end|teams-no-access)(\/|$)/;

export interface CanonicalHostWindow {
  location: Pick<Location, 'hostname' | 'pathname' | 'search' | 'hash'>;
  self: unknown;
  top: unknown;
  crewdleNative?: unknown;
  Capacitor?: { isNativePlatform?: () => boolean };
}

/** The app.* URL to move this tab to, or null to stay. */
export function canonicalHostRedirect(win: CanonicalHostWindow): string | null {
  const { hostname, pathname, search, hash } = win.location;
  const match = OLD_HOST.exec(hostname);
  if (!match) return null;
  if (win.self !== win.top) return null;
  if (win.crewdleNative || win.Capacitor?.isNativePlatform?.()) return null;
  if (OLD_HOST_ONLY_PATHS.test(pathname)) return null;
  return `https://app.${match[1]}${pathname}${search}${hash}`;
}
